import { ITableRowData, TableSelection } from './interfaces';

export const isRowSelected = (
  row?: ITableRowData,
  includes: TableSelection = new Set(),
  excludes: TableSelection = new Set(),
) => {
  if (!row?.id) return false;
  return (row.isSelected && !excludes.has(row.id)) || includes.has(row.id);
};
